import PropTypes from "prop-types";
import React from "react";
import { Box, Flex, Text, useMantineTheme } from "@mantine/core";
import {
  getIdentityAtStampTime,
  getUserAtStampTime,
  shouldShowIdentityAtStampTime,
  shouldShowUserAtStampTime,
} from "../utils/stampIdentity";

export const StampChangeFlag = ({ children }) => (
  <Text component="span" className="stamp-change-flag">
    <Text component="span" className="stamp-change-flag-dot" aria-hidden="true">
      •
    </Text>
    {children}
  </Text>
);

StampChangeFlag.propTypes = {
  children: PropTypes.node.isRequired,
};

const StampTimeDetailsRow = ({ label, value }) => {
  const theme = useMantineTheme();

  return (
    <Flex
      gap={theme.flex.gap.xxs}
      justify={theme.flex.justify.between}
      className="item"
      align={theme.flex.align.end}
    >
      <Text className="key">{label}</Text>
      <Box className="dots"></Box>
      <Text className="value value-without-copy">{value}</Text>
    </Flex>
  );
};

StampTimeDetailsRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export const StampTimeDetailsRows = ({ data }) => {
  const showUserAtStampTime = shouldShowUserAtStampTime(data);
  const showIdentityAtStampTime = shouldShowIdentityAtStampTime(data);

  if (!showUserAtStampTime && !showIdentityAtStampTime) {
    return null;
  }

  return (
    <Box className="stamp-time-details">
      {showUserAtStampTime && (
        <StampTimeDetailsRow
          label="User at Time of Stamp"
          value={getUserAtStampTime(data)}
        />
      )}
      {showIdentityAtStampTime && (
        <StampTimeDetailsRow
          label="User Identity at Time of Stamp"
          value={getIdentityAtStampTime(data)}
        />
      )}
    </Box>
  );
};

StampTimeDetailsRows.propTypes = {
  data: PropTypes.object.isRequired,
};
